/**
 * Marker the Google sign-up carries back on its redirect URL (`oauth=`), so the
 * callback knows where the new account goes next: an invited brand to its
 * Shopify onboarding, a brand that signed up on its own to the onboarding v2.
 */
export const OAUTH_BRAND_SIGNUP_MARKER = {
  INVITATION: 'brand_signup',
  SELF_SIGNUP: 'brand_self_signup',
} as const;
